import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 5" {...props}>
    <path fill="none" stroke="#FFF" d="m1 0 3.563 4.015L8.393 0" />
  </svg>
);
const Memo = memo(SvgDropdown);
export default Memo;
